import {createSelector} from "reselect";

const InventoryReports = (state) => state.inventoryReports;
const inventoryReportsData = createSelector(
  InventoryReports,
  (data) => data?.inventoryReportsData || {}
);

export const getInventoryReportsList = createSelector(
  inventoryReportsData,
  (data) => data?.results || []
);

export const getInventoryReportsTotalCount = createSelector(
  inventoryReportsData,
  (data) => data?.count
);

export const getInventoryReportsPaginationUrls = createSelector(
  inventoryReportsData,
  (data) => ({
    prevUrl: data?.previous,
    nextUrl: data?.next,
  })
);
